import { useState } from "react";
import "./app.css";
import "./custom.css";

const regions = [
    {
        name: "Auckland",
        restaurants: [
            {
                id: "729d8af7-a232-4292-8bfe-9ee99cac85c9",
                name: "Birkenhead",
                address: "259 Hinemoa Street, Birkenhead, Auckland 0626",
                available: true,
            },
            {
                id: "fa350d32-50f0-403b-900f-2b09c1cca74e",
                name: "Browns Bay",
                address: "27 Clyde Road, Browns Bay, Auckland 0630",
                available: true,
            },
            {
                id: "2520575c-7fde-4e64-aa08-d899caf9f76b",
                name: "Commerce St (Auckland CBD)",
                address: "8 Commerce Street, Auckland Central, Auckland 1010",
                available: true,
            },
            {
                id: "f7eaeffc-3c7a-45c3-984f-239613351c11",
                name: "Grafton",
                address: "10 Park Road, Grafton, Auckland 1010",
                available: true,
            },
            // {
            //     id: "3f24051a-ab84-4659-b8e9-48d8dea138c5",
            //     name: "Kelston",
            //     address: "4038 Great North Road, Kelston, Auckland 0602",
            //     available: true,
            // },
            // {
            //     id: "b626f354-1c10-4da9-9a3d-0d3ea1975d87",
            //     name: "Kohimarama",
            //     address: "3A Averill Avenue Kohimarama, Auckland (next to Kohi Beach)",
            //     available: true,
            // },
            {
                id: "24ab66c3-4631-42af-94d2-0cc272d136f1",
                name: "Manukau",
                address: "4/792 Great South Road, Manukau City Centre, Auckland 2241",
                available: true,
            },
            {
                id: "086d8fc1-2282-4c3b-a7d2-5c7a995d8e37",
                name: "Mount Albert",
                address: "940 New North Road, Mount Albert, Auckland 1025",
                available: true,
            },
            {
                id: "475b7a7d-474a-4b9e-935b-b5fefdf9715c",
                name: "Mount Eden",
                address: "225 Dominion Road, Mount Eden, Auckland 1024",
                available: true,
            },
            {
                id: "07b07ca3-a727-4446-b93b-924dea6b6620",
                name: "Mount Wellington",
                address: "Shop 10/295 Penrose Road, Mount Wellington, Auckland 1060",
                available: true,
            },
            {
                id: "097b7004-0cf1-400c-ac5b-7e5fc280be85",
                name: "Newmarket",
                address: "S362/277 Broadway, Newmarket, Auckland 1023",
                available: true,
            },
            {
                id: "6def38d8-1635-4425-af85-4519b5a76851",
                name: "Papatoetoe",
                address: "4 East Tamaki Road, Papatoetoe, Auckland 2025",
                available: true,
            },
            {
                id: "41ffc078-b012-4a3c-9b47-5e7c812903b8",
                name: "Royal Oak",
                address: "705 Manukau Road, Royal Oak, Auckland 1023",
                available: true,
            },
            {
                id: "dd3e377d-aa83-4593-b5b9-94d910854f52",
                name: "Takanini",
                address: "14/108 Great South Road, Takanini, Auckland 2112",
                available: true,
            },
            {
                id: "43d8857f-6fd6-48a9-9119-0c292c082877",
                name: "Takapuna",
                address: "484 Lake Road, Takapuna, Auckland 0622",
                available: true,
            },
            {
                id: "9dd63bcd-8308-47df-9f44-5b80cea00d47",
                name: "WestCity",
                address: "7 Catherine Street, Henderson, Auckland, 0612",
                available: true,
            },
        ],
    },
    {
        name: "Waikato",
        restaurants: [
            {
                id: "fc27fb65-ee7b-4a28-9ffe-9527e4119670",
                name: "Hamilton East",
                address: "372 Grey Street, Hamilton East, Hamilton 3216",
                available: true,
            },
            {
                id: "ea64c3f9-2864-4985-95fd-55819a343db7",
                name: "Te Awamutu",
                address: "254 Alexandra Street, Te Awamutu 3800",
                available: true,
            },
            {
                id: "874152cd-b7d8-4c25-b44b-135e1c05e455",
                name: "The Base",
                address: "Maahanga Dr, Te Rapa, Hamilton, 3200",
                available: true,
            },
        ],
    },
    {
        name: "Wellington",
        restaurants: [
            {
                id: "ea2cc097-8f61-4584-9156-1ce6ba50a142",
                name: "Courtenay Place",
                address: "38 Courtenay Place, Te Aro, Wellington 6011",
                available: true,
            },
            {
                id: "7424cc22-d52b-4e8a-b711-484f7b698ec5",
                name: "Petone",
                address: "45 Jackson Street, Petone, Lower Hutt 5012",
                available: true,
            },
            {
                id: "8c43051f-5be0-4efe-9fa3-0d8973d948e3",
                name: "Porirua",
                address: "6 Cobham Court, Porirua City Centre, Porirua 5022, New Zealand",
                available: true,
            },
            {
                id: "d594f771-55b9-45ad-9028-db0aa2d22829",
                name: "Willis Lane",
                address: "Tenancy 4, Basement One, 1 Willis Street, Wellington 6011",
                available: true,
            },
        ],
    },
    {
        name: "Masterton",
        restaurants: [
            {
                id: "b1789a5f-287a-47a7-9770-615e395cf6e3",
                name: "Masterton",
                address: "99A High Street, Solway, Masterton 5810",
                available: true,
            },
        ],
    },
];

const onOrder = (link) => {
    window.location.href = `https://order.tabin.co.nz/restaurant/${link}`;
};

export default function App() {
    const [expandedRegions, setExpandedRegions] = useState([]);

    const toggleRegion = (name) => {
        setExpandedRegions((current) => (current.includes(name) ? current.filter((regionName) => regionName !== name) : [...current, name]));
    };

    return (
        <div className="restaurant-list">
            <img src="https://d1hfsnuz4i23pd.cloudfront.net/public/2024-09-13_06:48:22.976-DL_Logo.webp" className="restaurant-list-logo" alt="logo" />
            <div className="select-location">Please select a location</div>
            {regions.map((region) => {
                const isExpanded = expandedRegions.includes(region.name);
                const panelId = `region-panel-${region.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;

                return (
                    <div key={region.name} className="restaurant-region-section">
                        <button
                            type="button"
                            className={`region-toggle ${isExpanded ? "open" : ""}`}
                            onClick={() => toggleRegion(region.name)}
                            aria-expanded={isExpanded}
                            aria-controls={panelId}
                        >
                            <span>{region.name}</span>
                            <span className="region-toggle-icon" aria-hidden="true">
                                {isExpanded ? "−" : "+"}
                            </span>
                        </button>
                        {isExpanded && (
                            <div id={panelId} className="region-content">
                                {region.restaurants.map((restaurant) => {
                                    const label = restaurant.comingSoon ? "Coming Soon" : restaurant.available ? "Order Here" : "Unavailable";

                                    const isDisabled = !restaurant.available;

                                    return (
                                        <div key={restaurant.id} className="restaurant-card">
                                            <div className="restaurant-card-details">
                                                <div className="restaurant-name mb-2">{restaurant.name}</div>
                                                {restaurant.address && <div className="restaurant-address">{restaurant.address}</div>}
                                            </div>
                                            <div className="restaurant-card-actions">
                                                <button
                                                    type="button"
                                                    className={`button ${isDisabled ? "disabled" : ""}`}
                                                    disabled={isDisabled}
                                                    onClick={() => {
                                                        if (!isDisabled) {
                                                            onOrder(restaurant.id);
                                                        }
                                                    }}
                                                >
                                                    {label}
                                                </button>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
}
